export default __webpack_public_path__ + "8697187.ttf";